<template>
  <div
    :class="{
      warn1: true,
      slash: false,
      /*'red-warn1': data.level === 2 ? true : false,
      'yellow-warn1': data.level === 1 ? true : false,
      'warn1_green': styleType=='typeGreen',
      'red-warn1_green': (data.level === 2&&styleType=='typeGreen') ? true : false,
      'yellow-warn1_green':(data.level === 1&&styleType=='typeGreen')  ? true : false,*/
    }"
  >
    <div class="warn1_title">
      <div class="popup-type1-title" :class="{ 'popup-type1-title_green': treatType }">
        <template v-if="data.analyzeResult && data.warnType == 5">
          {{ "道路" }}-{{ "污染识别" }}
        </template>
        <template v-else>
          {{ data.typeName }}-{{
            data.metric +
            (data.warnType === 1 && data.metric === "TSP"
              ? "告警"
              : data.warnType === 1 && data.metric === "VDM浓度"
              ? "告警"
              : data.warnType === 1
              ? "告警"
              : data.warnType === 2
              ? "超低"
              : "")
          }}
        </template>
      </div>
      <div class="popup-type1-time" v-if="data.warnType == 5">
        {{ data.createTime ? data.createTime.slice(5, 16) : "" }}
      </div>
      <div class="popup-type1-time" v-else>
        {{ data.eventTime ? data.eventTime.slice(5, 16) : "" }}
      </div>
    </div>

    <div class="warn1_content">
      <div class="warn1_state">
        闭环控制状态: <span :class="{ done_green: treatType }">{{ handleState_ }}</span>
      </div>
      <div class="warn1_position">
        发生位置:
        <span>{{ data.deviceName }}</span
        ><span
          style="
            font-size: 16px;
            color: rgb(204, 204, 204);
            display: block;
            text-align: center;
            padding: 5px 0;
          "
          >{{
            sourceData && sourceData.length > 0 && data.warnType != 5
              ? "相关排放源数量(" + sourceData.length + ")"
              : ""
          }}</span
        >
      </div>
      <template v-if="data.warnType == 5">
        <div class="warn1_road_info">
          统计时间:
          <span
            >{{ data.analyzeResult.startTime }} ~
            {{
              data.analyzeResult.endTime ? data.analyzeResult.endTime.slice(11, 19) : ""
            }}</span
          >
        </div>
        <div class="warn1_road_info">
          全厂PM10均值:
          <span
            >{{
              data.analyzeResult.pm10AvgFactory ? data.analyzeResult.pm10AvgFactory : "--"
            }}
            μg/m³</span
          >
        </div>
        <div class="warn1_road_info">
          PM10均值:
          <span
            >{{
              data.analyzeResult.pm10AvgRoad ? data.analyzeResult.pm10AvgRoad : "--"
            }}
            μg/m³</span
          >
        </div>
        <div class="warn1_charts new-chart-style" v-if="data.chartRoadPM10">
          <div class="warn1_charts_inner" ref="chartRoadPM10"></div>
        </div>
        <div
          class="warn1_road_info"
          v-if="data.analyzeResult && data.analyzeResult.vdmAvgRoad"
        >
          VDM均值: <span>{{ data.analyzeResult.vdmAvgRoad }} μg/m³</span>
        </div>
        <div
          class="warn1_charts new-chart-style"
          v-if="data.analyzeResult && data.analyzeResult.vdmAvgRoad"
        >
          <div class="warn1_charts_inner" ref="chartRoadVDM"></div>
        </div>
      </template>
    </div>
    <template v-if="data.warnType != 5">
      <div class="warn1_box" v-show="!treatType">
        <div class="smallBox">
          <div class="warn1_type_name">{{ data.metric }}</div>
          <div class="warn1_type_num">{{ data.value }}</div>
          <div class="warn1_type_unit">{{ data.unit }}</div>
        </div>
      </div>
    </template>
    <template v-if="data.warnType != 5">
      <div class="warn1_charts" v-show="!treatType && haveData">
        <div class="warn1_charts_inner" ref="chart"></div>
      </div>
    </template>

    <div class="treatRecords">
      <div class="treatTitle">处理记录：</div>
      <ul class="treatList">
        <li class="treatEveryList" v-for="(item, i) in treatRecords" :key="i">
          <div class="listLeft">
            <div class="listStatus">{{ item.state }}</div>
            <div class="treatMan" v-show="Boolean(item.receiveUserName)">
              {{ item.receiveUserName }}
            </div>
          </div>

          <div class="listTime">{{ item.createTime }}</div>
        </li>
      </ul>
    </div>
    <div
      class="warn1_project_25"
      :class="{
        warn1_project_50: treatRecords.length == 2,
        warn1_project_75: treatRecords.length == 3,
        warn1_project_100: treatRecords.length >= 4,
      }"
    ></div>
  </div>
</template>
<script>
import getOpt from "./js/chartOpt.js";
import { unwarp } from "@/utils/tools.js";
import { unref } from "vue";

export default {
  components: {},
  props: ["data", "typeId"],
  inject: ["getWarnSourceData"],
  data() {
    return {
      customerId: this.$store.state.customerId,
      chart: null,
      chartRoadPM10: null,
      chartRoadVDM: null,
      unit: 1,
      handleState_: "",
      treatRecords: [],
      treatType: false,
      warnType: "",
      pmData: {
        xData: [],
        y1Data: [],
      },
      roadPM10Data: {
        xData: [],
        y1Data: [],
      },
      roadVDMData: {
        xData: [],
        y1Data: [],
      },
      haveData: true,
      sourceData: [],
      styleType: "",
    };
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  created() {
    if (this.$store.state.customerId == 46) {
      this.data.metric = this.data.metric.replace("VDM", "TSP");
      this.data.typeName = this.data.typeName.replace("VDM", "TSP");
    }
    this.styleType = this.$store.state.styleType;
    if (this.$store.state.customerId == 46) {
      this.data.metric = this.data.metric.replace("VDM", "TSP");
      this.data.typeName = this.data.typeName.replace("VDM", "TSP");
    }
    this.styleType = this.$store.state.styleType;
  },
  watch: {
    getWarnSourceData: {
      handler(newVal, oldVal) {
        let tmpObj = unref(newVal);
        this.sourceData = tmpObj;
      },
      deep: true,
    },
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
        this.typeChange();
      },
      deep: true,
    },
  },
  mounted() {
    this.treatRecords = this.data.forwards;
    if (this.treatRecords.length) {
      this.treatRecords.forEach((v, i) => {
        if (v.state == 1) {
          v.state = "已创建";
        } else if (v.state == 2) {
          v.state = "已处理";
        } else if (v.state == 3) {
          v.state = "已分配";
        } else if (v.state == 4) {
          v.state = "处理中";
        }
      });

      // 如果是道路让它只显示最后三条数据
      if (this.data.warnType == 5 && this.chartRoadVDM && this.treatRecords.length >= 3) {
        this.treatRecords = this.treatRecords.slice(-3);
      }
    }
    if (this.data) {
      if (this.data.warnType == 1) {
        this.warnType = "超标";
      } else if (this.data.warnType == 2) {
        this.warnType = "超低";
      } else if (this.data.warnType == 3) {
        this.warnType = "同步率";
      }
    }
    if (this.data) {
      if (this.data.handleState == 0 || this.data.handleState == 1) {
        this.handleState_ = "处理中";
      } else if (this.data.handleState == 2) {
        this.handleState_ = "已处理";
        this.treatType = true;
      } else if (this.data.handleState == 3) {
        this.handleState_ = "已撤销";
        this.treatType = true;
      } else {
        this.handleState_ = "未知状态";
      }
    }
    if (this.data) {
      if (this.data.typeName && this.data.typeName.indexOf("微站") != -1) {
        this.data.typeName = "微站";
      } else if (this.data.typeName && this.data.typeName.indexOf("CEMS") != -1) {
        this.data.typeName = "CEMS";
      }
    }
    this.getData();
    this.typeChange();
  },
  unmounted() {},
  beforeUnmount() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  activated() {
    this.getData();
  },
  methods: {
    typeChange() {
      if (this.styleType == "typeGreen") {
        this.$nextTick(() => {});
      } else if (this.styleType == "typeDark") {
        this.$nextTick(() => {});
      }
    },
    formatDate(date) {
      var date = new Date(date * 1000);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
        "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm;
    },
    getData() {
      let that = this;
      if (this.data.valueHistory && this.data.valueHistory.length > 0) {
        let dpsObj = this.data.valueHistory[0].dps;
        if (dpsObj) {
          this.haveData = true;
          let arrNewX = [];
          let arrNewY = [];
          for (let i in dpsObj) {
            arrNewY.push(dpsObj[i] ? dpsObj[i].toFixed(2) : dpsObj[i]); //值 ['aaa' 190 'man']
            arrNewX.push(this.formatDate(parseInt(i))); //属性  ['name' 'height' 'sex']
          }
          this.pmData.xData = arrNewX;
          this.pmData.y1Data = arrNewY;
          this.$nextTick(() => {
            try {
              if (!that.chart) {
                that.chart = echarts.init(that.$refs.chart);
              }
              let optionStr = getOpt(that.pmData);
              unwarp(that.chart).setOption(optionStr);
            } catch (err) {
              console.log(err);
            }
          });
        }
      } else {
        this.haveData = false;
      }

      if (this.data.chartRoadVDM) {
        let dpsObj = this.data.chartRoadVDM;
        // let dpsObj = {
        //   1634205000: 4299.5,
        //   1634205600: 4691.277777777777,
        //   1634206200: 4504.722222222223,
        //   1634206800: 4247.176470588235,
        //   1634207400: 3348.0526315789475,
        //   1634208000: 4616.777777777777
        // }
        if (dpsObj) {
          this.haveData = true;
          let arrNewX = [];
          let arrNewY = [];
          for (let i in dpsObj) {
            arrNewY.push(dpsObj[i] ? dpsObj[i].toFixed(2) : dpsObj[i]); //值 ['aaa' 190 'man']
            arrNewX.push(this.formatDate(parseInt(i))); //属性  ['name' 'height' 'sex']
          }
          this.roadPM10Data.xData = arrNewX;
          this.roadPM10Data.y1Data = arrNewY;
          this.$nextTick(() => {
            try {
              if (!that.chartRoadVDM) {
                that.chartRoadVDM = echarts.init(that.$refs.chartRoadVDM);
              }
              let optionStr = getOpt(that.roadPM10Data);
              unwarp(that.chartRoadVDM).setOption(optionStr);
            } catch (err) {
              console.log(err);
            }
          });
        }
      }

      if (this.data.chartRoadPM10) {
        let dpsObj = this.data.chartRoadPM10;
        // let dpsObj = {
        //   1634205000: 4299.5,
        //   1634205600: 4691.277777777777,
        //   1634206200: 4504.722222222223,
        //   1634206800: 4247.176470588235,
        //   1634207400: 3348.0526315789475,
        //   1634208000: 4616.777777777777
        // }
        if (dpsObj) {
          this.haveData = true;
          let arrNewX = [];
          let arrNewY = [];
          for (let i in dpsObj) {
            arrNewY.push(dpsObj[i] ? dpsObj[i].toFixed(2) : dpsObj[i]); //值 ['aaa' 190 'man']
            arrNewX.push(this.formatDate(parseInt(i))); //属性  ['name' 'height' 'sex']
          }
          this.roadVDMData.xData = arrNewX;
          this.roadVDMData.y1Data = arrNewY;
          this.$nextTick(() => {
            try {
              if (!that.chartRoadPM10) {
                that.chartRoadPM10 = echarts.init(that.$refs.chartRoadPM10);
              }
              let optionStr = getOpt(that.roadVDMData);
              unwarp(that.chartRoadPM10).setOption(optionStr);
            } catch (err) {
              console.log(err);
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.warn1 {
  position: absolute;
  padding: 30px;
  width: 450px;
  height: 782px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.75) 100%);
  background-size: 100% 100%;
  border-radius: 8px;
  box-shadow: 0px -2px 0px 0px #51eeff, 0px 2px 4px 0px rgba(0, 0, 0, 0.75);
  .warn1_title {
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid;
    border-image: linear-gradient(-90deg, #4fa7ff, #88f7ff) 1 1;
    justify-content: space-between;
    .popup-type1-title {
      height: 30px;
      font-size: 22px;
      font-weight: 500;
      color: #ff7373;
      line-height: 30px;
      display: flex;
      align-items: center;
      // flex-wrap: nowrap;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
      text-align: left;
      &::before {
        content: "";
        display: block;
        width: 7px;
        height: 7px;
        background: #ff7373;
        box-shadow: 0px 0px 7px 0px #df3131;
        border: 1px solid #da3636;
        border-radius: 50%;
        display: inline-block;
        margin-right: 16px;
      }
    }
    .popup-type1-time {
      // height: 14px;
      padding-bottom: 5px;
      font-size: 14px;
      color: #ffffff;
      line-height: 14px;
      width: 90px;
    }
  }
  .warn1_content {
    margin-top: 20px;
    .warn1_state {
      height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      margin-bottom: 15px;
      span {
        color: #f4c48f;
        font-weight: 500;
      }
    }
    .warn1_road_info {
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 30px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .warn1_position {
      //height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .new-chart-style {
      margin-bottom: 10px;
    }
  }
  .warn1_box {
    margin-top: 20px;
    width: 100%;
    height: 126px;
    background: rgba(0, 0, 0, 0.42);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.66);
    padding: 13px 79px;

    .smallBox {
      @include bg-box(100%, 100px, "warn1_bg.png");
      text-align: center;
      padding-top: 10px;
      .warn1_type_name {
        height: 16px;
        font-size: 16px;
        color: #99f5ff;
        line-height: 16px;
        margin-bottom: 15px;
      }
      .warn1_type_num {
        height: 32px;
        font-size: 32px;
        color: #ffffff;
        line-height: 32px;
        margin-bottom: 5px;
        text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.32);
      }
      .warn1_type_unit {
        height: 12px;
        font-size: 12px;
        color: #aaaaaa;
        line-height: 12px;
        text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.3);
      }
    }
  }
  .warn1_charts {
    width: 390px;
    height: 135px;
    margin-top: 10px;
    .warn1_charts_inner {
      width: 390px;
      height: 135px;
    }
  }
  .new-chart-style {
    width: 390px;
    height: 100px;
    margin-top: 5px;
    .warn1_charts_inner {
      width: 390px;
      height: 100px;
    }
  }
  .treatRecords {
    width: 100%;
    margin-top: 20px;
    .treatTitle {
      height: 18px;
      font-size: 18px;
      color: #94a2b0;
      line-height: 18px;
    }
    ul.treatList {
      padding-left: 30px;
      margin-top: 15px;
      position: relative;
      &::before {
        content: "";
        width: 1px;
        background-color: #51eeff;
        height: calc(100% - 40px);
        display: block;
        position: absolute;
        top: 20px;
        left: 15px;
      }
      li {
        height: 40px;
        border-bottom: 1px solid #4069ad;
        display: flex;
        font-size: 16px;
        color: #e8f2fc;
        line-height: 40px;
        align-items: center;
        position: relative;
        justify-content: space-between;
        .listLeft {
          display: flex;
          align-items: center;
          .listStatus {
            margin-right: 20px;
            &:before {
              content: "✔";
              color: #313131;
              line-height: 12px;
              width: 12px;
              height: 12px;
              font-size: 10px;
              top: 13px;
              background: #99f5ff;
              position: absolute;
              left: -20px;
              border-radius: 50%;
            }
          }
          .treatMan {
            width: 100px;
            height: 24px;
            background: #068acb;
            border-radius: 4px;
            line-height: 24px;
            text-align: center;
          }
        }
      }
    }
  }
  .warn1_project_25 {
    margin: 0 auto;
    @include bg-box(416px, 118px, "project_25.png");
  }
  .warn1_project_50 {
    @include bg-box(416px, 118px, "project_50.png");
  }
  .warn1_project_75 {
    @include bg-box(416px, 118px, "project_75.png");
  }
  .warn1_project_100 {
    @include bg-box(416px, 118px, "project_100.png");
  }
}

@keyframes fade {
  from {
    opacity: 1;
  }
  25% {
    opacity: 0.9;
  }
  50% {
    opacity: 0.8;
  }
  75% {
    opacity: 0.9;
  }
  to {
    opacity: 1;
  }
}

@-webkit-keyframes fade {
  from {
    opacity: 1;
  }
  25% {
    opacity: 0.9;
  }
  50% {
    opacity: 0.8;
  }
  75% {
    opacity: 0.9;
  }
  to {
    opacity: 1;
  }
}

.slash {
  animation: fade 2500ms infinite;
  -webkit-animation: fade 2500ms infinite;
}

.yellow-warn1 {
  background: linear-gradient(180deg, #6b6210 75%, #6b6210 100%) !important;
}

.red-warn1 {
  background: linear-gradient(180deg, #460000 75%, #460000 100%) !important;
}
.warn1.warn1_green {
  background-image: url("./img/warn1_green.png");
  background-size: 100% 100% !important;
}
.warn1.red-warn1_green {
  background-image: url("./img/warn1red_green_.png") !important;
  background-size: 100% 100% !important;
}
.warn1.yellow-warn1_green {
  background-image: url("./img/warn1yellow_green_.png") !important;
  background-size: 100% 100% !important;
}
</style>
<style lang="scss" scoped>
.popup-type1-title_green {
  color: #30d594 !important;
  &::before {
    background: #dffff3 !important;
    box-shadow: 0px 0px 7px 0px rgba(48, 213, 148, 0.81) !important;
    border: 1px solid #30d594 !important;
  }
}
.done_green {
  color: #30d594 !important;
}
</style>
